import { DatePicker } from 'antd'
import useTranslation from '@/hooks/useTranslation'

import Calendar from '../../svgs/formBuild/Calendar.js'

const { RangePicker } = DatePicker
const dateFormat = 'DD-MM-YYYY'

export default function RangePickerC({ onChange }) {
  const { t } = useTranslation()

  return (
    <div className='input'>
      <label htmlFor='date'>{t('table.filter.date')}</label>
      <RangePicker
        id='date'
        name='date'
        format={dateFormat}
        placeholder={[t('Start date'), t('End date')]}
        suffixIcon={<Calendar style='w-24' />}
        onCalendarChange={(_, rangeString) => onChange(rangeString)}
      />
    </div>
  )
}
